<template>
  <div class="console-overlay">
    <div class="console-title">Receiver diagnostics · live logs</div>
    <div
      v-for="(line, index) in reversedLogs"
      :key="index"
      class="log-line"
      :style="{ backgroundColor: getBgColor(index) }"
    >
      {{ line }}
    </div>
  </div>
</template>

<script>
export default {
  name: "ConsoleOverlay",
  data() {
    return {
      logs: [],
      maxLogs: 100,
    };
  },
  computed: {
    reversedLogs() {
      return [...this.logs].reverse();
    }
  },
  created() {
    this.logs.push('Log overlay enabled. Waiting for receiver events…')
    this.originalConsole = {}
    for (const method of ['log', 'info', 'warn', 'error']) {
      this.originalConsole[method] = console[method].bind(console)
      console[method] = (...args) => {
        const line = args.map(arg => {
          try { return typeof arg === 'object' ? JSON.stringify(arg) : String(arg) }
          catch { return String(arg) }
        }).join(' ')
        this.logs.push(`[${method}] ${line}`)
        if (this.logs.length > this.maxLogs) this.logs.shift()
        this.originalConsole[method](...args)
      }
    }
  },
  beforeUnmount() {
    for (const method of Object.keys(this.originalConsole || {})) {
      console[method] = this.originalConsole[method]
    }
  },
  methods: {
    getBgColor(index) {
      const hue = (index * 35) % 360;            // More variation in hue
      const saturation = 50 + (index % 2) * 10;  // Alternate saturation: 50% or 60%
      const lightness = 18 + (index % 3) * 6;    // Vary lightness: 18%, 24%, 30%
      return `hsl(${hue}, ${saturation}%, ${lightness}%)`;
    }
  }
};
</script>

<style scoped>
.console-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  max-height: 60vh;
  overflow-y: auto;
  z-index: 9999;
  font-family: monospace;
  font-size: 11px;
  color: white;
  pointer-events: none;
  background: rgba(0, 0, 0, 0.78);
  border-bottom: 2px solid #ffd166;
}
.console-title {
  position: sticky;
  top: 0;
  z-index: 1;
  padding: 7px 9px;
  font-weight: 700;
  color: #ffd166;
  background: rgba(14, 18, 30, 0.96);
}
.log-line {
  padding: 2px 6px;
  white-space: pre-wrap;
  word-break: break-word;
}
</style>
